export const defaultTabs = [
  {
    id: 'content',
    label: __('Content'),
  },
  {
    id: 'style',
    label: __('Style'),
  },
];
